// @flow
import { makeGetRequest } from '../../utils'

import type { Categories } from '../../types/categories'
import type { ResponseAPI } from '../../types/api'

export const getTvShowCategories = (domain: string, serviceId: string): Promise<ResponseAPI<Categories>> =>
  makeGetRequest(`${domain}/client/api/servicespec/${serviceId}/tv-show/categories`)
